import { createGetApiHook } from "@/shared";

type MainCardActivityParams = {
  id: number;
  type?: string;
  offset?: number;
  limit?: number;
  headers?: Record<string, string>;
};

const getMainCardActivity = ({
  id,
  headers: _headers,
  ...queryParams
}: MainCardActivityParams): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(fullParams)
        .filter(([, value]) => value != null)
        .map(([key, value]) => [key, String(value)])
    )
  ).toString();

  return `/main-card/${id}/events?${queryString}`;
};

export const useGetMainCardActivity = createGetApiHook<any, MainCardActivityParams>(
  getMainCardActivity
);
